var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mx-3",class:_vm.checkTheme,style:(_vm.theme === 'light' ? { background: _vm.backgroundColor } : ''),attrs:{"height":_vm.height,"width":_vm.width}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }